module.exports = "<button class=\"button button_small button_green\" ng-click=\"photoLibraryModal()\" type=\"button\">{{'modulesSettings.chooseFromLibrary' | translate}}</button>";


//////////////////
// WEBPACK FOOTER
// ./~/html-loader!./~/pug-html-loader/lib!./src/app/editor/modules_settings/photo-library/template.jade
// module id = 347
// module chunks = 0